var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgClose = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "17px",
    viewBox: "0 0 16 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-328.000000, -55.000000)",
    fill: "#fff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.000000, 55.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(296.000000, 0.750000)"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "translate(7.885725, 8.018188) rotate(45.000000) translate(-7.885725, -8.018188) ",
    x: -2.26637435,
    y: 7.01818848,
    width: 20.3041992,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "translate(7.885725, 8.018188) rotate(-45.000000) translate(-7.885725, -8.018188) ",
    x: -2.26637435,
    y: 7.01818848,
    width: 20.3041992,
    height: 2
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClose, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close.cf6a42e1.svg";
export { ForwardRef as ReactComponent };